/**
 * Kształt filtra listy firm - to, co ekran wysyła do API.
 *
 * Mieszkało w `app/components/common/companyFilterDropdown`, więc modele, akcje
 * i warstwa API importowały typ domenowy z komponentu UI. Tutaj jest neutralnie.
 *
 * UWAGA: `CompanyType` poniżej to LICZBOWY enum filtra (0/1/2), którego oczekuje
 * backend - to co innego niż tekstowy `CompanyType` z `app/constants/companyType`
 * (`NORMAL`/`SERVICE`/`ACCOUNTING`) używany w modelach. Nie scalać bez sprawdzenia
 * kontraktu API.
 */
export interface CompanyFilterResult {
  companyTypes?: Array<CompanyType>
  companySettlementTypes?: Array<CompanySettlementType>
  packageOptions?: Array<PackageOption>
  synchronizationOptions?: Array<SynchronizationOption>
  packageProposalOptions?: Array<PackageProposalOption>
  subscriptionExpirationDateOptions?: Array<SubscriptionExpirationDateOption>
  suspendedOptions?: Array<SuspendedOption>
  searchValue?: string
  subcompanies?: boolean
  serverId?: number
  databaseId?: number
}

export enum PackageProposalOption {
  None = 0,
  Propose = 1,
}

export enum SuspendedOption {
  None = 0,
  Temporary = 1,
  Permanently = 2,
}

export enum SubscriptionExpirationDateOption {
  None = 0,
  Defined = 1,
}

export enum CompanySettlementType {
  Basic = 0,
  Pro = 1,
}

export enum CompanyType {
  Normal = 0,
  Service = 1,
  Accounting = 2,
}

export enum PackageOption {
  NoPackage = 0,
  Package = 1,
}

export enum SynchronizationOption {
  NoSynchronization = 0,
  Updater = 1,
  VPN = 2,
}
